module.exports = __webpack_public_path__ + "static/media/yhh logo.da0dc096.jpg";